import { useFetch } from "@hooks/useAuthApi";
import QCP_API from "api/qcpApi";
import React from "react";
import InnerImageZoom from "react-inner-image-zoom";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";

const imageQCPData = [
  { id: 1, src: "qcp-img1.png" },
  { id: 2, src: "qcp-img1.png" },
  { id: 3, src: "qcp-img1.png" },
  { id: 4, src: "qcp-img1.png" },
  { id: 5, src: "qcp-img1.png" },
  { id: 6, src: "qcp-img1.png" }
];



const QCP_ImageCards = ({images}) => {

  return (
    <>
      <div className="flex items-center justify-start rounded-md border space-2 bg-gray-50 overflow-hidden dark-bg p-3">
        {images?.map((image) => (
          <div key={image.id} className="lg:w-[32%] w-auto h-fit">
            <img
              style={{height: "30vh"}}
              src={image.imageURL}
              // zoomSrc={`${process.env.REACT_APP_PUBLIC_URL}/${image.ImageURL}`}
              zoomType="hover"
              zoomScale={3}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default QCP_ImageCards;
